export default {
  FILTER_MY_SURVEY_LIST: 'FilterMysurveyList',
  SORT_MY_SURVEY_LIST: 'SortMysurveyList',
  LOAD_MY_SURVEY_LIST_START: 'LoadMysurveyListStart',
  LOAD_MY_SURVEY_LIST_END: 'LoadMysurveyListEnd',
  SEARCH_MY_SURVEY_LIST_RESIDENTS_COMBOBOX_START: 'SearchMySurveyListResidentComboBoxStart',
  SEARCH_MY_SURVEY_LIST_RESIDENTS_COMBOBOX_END: 'SearchMySurveyListResidentComboBoxEnd'
};